function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M144 192h224c9 0 16-7 16-16v-32c0-9-7-16-16-16H144c-9 0-16 7-16 16v32c0 9 7 16 16 16zm0 96h224c9 0 16-7 16-16v-32c0-9-7-16-16-16H144c-9 0-16 7-16 16v32c0 9 7 16 16 16zm304 64h-68c-14 55-64 96-124 96s-110-41-124-96H64V64h384zM480 0H32C14 0 0 14 0 32v448c0 18 14 32 32 32h448c18 0 32-14 32-32V32c0-18-14-32-32-32z"
})));